import { recordPath, recordRoute } from '@/shared/registry'

/** Where the WebEx connection pages live. */
export const webExConnectionsPath = '/classes/webex-connections'
export const createWebExConnectionPath = `${webExConnectionsPath}/new`
export const webExConnectionRoute = recordRoute('classes', 'webex-connections')
export const editWebExConnectionRoute = `${webExConnectionRoute}/edit`

/** A connection's details page. */
export function webExConnectionPath(id: string): string {
  return recordPath('classes', 'webex-connections', id)
}

/** The base of WebEx Connection Details' slots (`detailsSlots`). */
export const webExConnectionDetailsSlot = 'classes.webex-connection-details'

/** The API's connection endpoints. */
export const webExConnectionsApi = '/classes/v1/webex-connections'

export function webExConnectionApi(id: string): string {
  return `${webExConnectionsApi}/${encodeURIComponent(id)}`
}

/** The connections the class form offers for a class owned by the organization. */
export function webExConnectionChoicesApi(organizationId: string): string {
  return `${webExConnectionsApi}/choices?organizationId=${encodeURIComponent(organizationId)}`
}

/** What each action needs; creating one, sending credentials or a new site URL also needs `credentials`. */
export const readWebExConnectionsPermission = 'classes.webex-connections.read'
export const writeWebExConnectionsPermission = 'classes.webex-connections.write'
export const deleteWebExConnectionsPermission = 'classes.webex-connections.delete'
export const writeWebExCredentialsPermission = 'classes.webex-connections.credentials.write'
